import { Expose } from 'class-transformer'

import { Base } from './Base'

export class CustomFieldValue extends Base {
  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''
  label: string = ''
  value: string = ''
}
